import { PackageUserWithDisplayName } from 'src/app/features/package-users/util';

export const isParticipantCheckedIn = (
  participant: PackageUserWithDisplayName | undefined
): boolean =>
  participant?.checkInStatus?.isCompletedExternally === true ||
  participant?.checkInStatus?.isCompleted === true;

/** A card shows Continue only when the participant checked in elsewhere and is not yet on this device. */
export const showsContinueButton = (
  participant: PackageUserWithDisplayName | undefined,
  associatedUsers: string[] | undefined
): boolean =>
  isParticipantCheckedIn(participant) &&
  !associatedUsers?.includes(participant.packageUserGuid);
